<template>
	<div class="mAboutLansuContainer">
		<div class="menuBox">
			<div class="menuImgBox" @click="open">
				<img class="menuImg" src="../../assets/mImg/menuIcon.png" alt="">
			</div>
			<div class="lansuImgBox">
				<img class="lansuImg" src="../../assets/logo2.png" alt="">
			</div>
			<!-- <div class="blackBox"></div> -->
		</div>
		<div class="firstBox">
			<img class="mFirst" src="../../assets/mImg/mAboutBg.jpg">
		</div>
		<el-drawer class="drawerBox" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
			unique-opened>
			<el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" @open="handleOpen"
				@close="handleCloseMenu" router>
				<el-menu-item index="/m">
					<i class="el-icon-s-home"></i>
					<span slot="title">首页</span>
				</el-menu-item>
				<el-menu-item index="/maboutLansu">
					<i class="el-icon-document"></i>
					<span slot="title">关于我们</span>
				</el-menu-item>
				<el-menu-item index="/mbrandLansu">
					<i class="el-icon-data-analysis"></i>
					<span slot="title">美业菩提</span>
				</el-menu-item>
				<el-menu-item index="/mDynamicLanshu">
					<i class="el-icon-star-off"></i>
					<span slot="title">菩提基金会</span>
				</el-menu-item>
				<el-submenu index="5">
					<template slot="title">
						<i class="el-icon-trophy"></i>
						<span>兰树品牌</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mhuaibrand">淮树</el-menu-item>
						<el-menu-item index="/mxinbrand">心清堂</el-menu-item>
						<el-menu-item index="/mshuibrand">水姻缘</el-menu-item>
						<el-menu-item index="/myibrand">一清堂</el-menu-item>
						<!-- <el-menu-item index="/mzhongbrand">Dr.CHUNG<span style="vertical-align: super;">+</span></el-menu-item> -->
						<el-menu-item index="/mlanshuBrand">兰树</el-menu-item>
						<el-menu-item index="/mzbqfBrand">植本清方</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item index="/mTrends">
					<i class="el-icon-bell"></i>
					<span slot="title">兰树动态</span>
				</el-menu-item>
			</el-menu>

		</el-drawer>
		<img class="mSecond"  src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_10-41-56_21731.png" alt="">
		<div class="mhomeSecondBox">
			<div class="titleBox">
				<div class="tb_left">
					<div class="aboutLine"></div>
					<div class="aboutTitle1">兰树简介</div>
					<div class="aboutTitle2">COMPANY INTRODUCTION</div>
				</div>
				<div class="tb_right">
					<img src="../../assets/mImg/icon.png" alt="">
				</div>
				
			</div>
			
			<div class="mhomeSecondMain">
				<div class="mhomeSecondMainText1">
					兰树化妆品股份有限公司（前身浙江兰树化妆品有限公司），初创时即设有皮肤专科门诊、美容连锁机构、植物及精油提取基地。 经过不断发展，逐渐成为集研发、生产、销售为一体的民族化妆品公司。 发展至今，共拥有员工300余人，其中仅研发部门就有40余人。
				</div>
				<div class="mhomeSecondMainText2">
					公司旗下拥有「淮树」、「心清堂」、「一清堂」、「水姻缘」、「Dr.chung+」等品牌，满足不同消费者的需求。
					目前，兰树企业拥有全国省级经销商公司 80 余家，线下 CS 及专业美容院签约合作门店 2 万余家，覆盖全国大部分城市、县城及1万多个城镇。现已成为中国市场业务规模和增长速度最快的化妆品公司之一。
				</div>
				<div class="mhomeSecondMainText2">
					兰树化妆品股份有限公司以天然草本、健康护肤为企业核心理念立足国内，成功打造“淮树”、“心清堂”、“一清堂”、“水姻缘”、“Dr.CHUNG”等各品牌。兰树企业以“传承中医国粹
					弘扬中医美容”为企业使命，追求卓越，不断创新。
					2018年兰树企业新园区落户湖州莫干山国家级高新区，占地约85 亩、投资人民币 5.5
					亿元的现代化花园式工厂已于2020年底完工投产，同时引进德国伊喀拓及日本美之贺乳化设备，品质和产能全方位提升...
				</div>
			</div>
			<!-- <img class="seeMore" src="../../assets/seeMore.png" alt=""> -->
		</div>

		<div class="mThirdBox">
			<div class="titleBox">
				<div class="tb_left">
					<div class="aboutLine"></div>
					<div class="aboutTitle1">兰树价值观</div>
					<div class="aboutTitle2">COMPANY VALUE</div>
				</div>
				<div class="tb_right">
					<img src="../../assets/mImg/icon.png" alt="">
				</div>
			</div>


			<div class="valueImg">
				<img src="../../assets/mImg/value1.png" alt="">
			</div>
			<div class="valueImg">
				<img src="../../assets/mImg/value2.png" alt="">
			</div>
			<div class="valueImg">
				<img src="../../assets/mImg/value3.png" alt="">
			</div>

		</div>

		<div class="mForthBox">
			<div class="titleBox">
				<div class="tb_left">
					<div class="aboutLine"></div>
					<div class="aboutTitle1">企业文化</div>
					<div class="aboutTitle2">COMPANY CULTURE</div>
				</div>
				<div class="tb_right">
					<img src="../../assets/mImg/icon.png" alt="">
				</div>
			</div>
			
			<wc-swiper class="swiperItemBox1">
				<wc-slide v-for="(item,index) in cultureData" :key="index" :class="styleData[index]">
					<div class="swiperBoxMain2">
						<img class="cultureBoxImg" :src="item.img" alt="">
						<div class="cultureText">{{item.text}}</div>
						<div class="cultureTitle">{{ item.title1 }}</div>
					</div>
				</wc-slide>
			</wc-swiper>
		</div>

		<div class="mFifthBox">
			<div class="titleBox">
				<div class="tb_left">
					<div class="aboutLine"></div>
					<div class="aboutTitle1">企业理念</div>
					<div class="aboutTitle2">COMPANY IDEA</div>
				</div>
				<div class="tb_right">
					<img src="../../assets/mImg/icon.png" alt="">
				</div>
			</div>
			<div class="mFifthBoxMain">
				<div class="mFifthBoxMainFirst mFifthBoxLine">
					<div class="mFifthBoxLineItemLeft">
						<img class="mFifthItemImg" src="../../assets/aboutLanshu/product.png" alt="">
						<div class="mFifthItemTitle1">产品理念</div>
						<div class="ideaTitle3">product concept</div>
						<div class="mFifthItemTitle2">产品是企业的根与灵魂</div>
					</div>
					<div class="mFifthBoxLineItemRight">
						<img class="mFifthItemImg" src="../../assets/aboutLanshu/manage.png" alt="">
						<div class="mFifthItemTitle1">管理理念</div>
						<div class="ideaTitle3">Management philosophy</div>
						<div class="mFifthItemTitle2">领导做正确的事 团队正确做事</div>
					</div>
				</div>
				<div class="mFifthBoxMainSecond mFifthBoxLine">
					<div class="mFifthBoxLineItemLeft">
						<img class="mFifthItemImg" src="../../assets/aboutLanshu/learn.png" alt="">
						<div class="mFifthItemTitle1">学习理念</div>
						<div class="ideaTitle3">Learning philosophy</div>
						<div class="mFifthItemTitle2">吾必每日三省吾身</div>
					</div>
					<div class="mFifthBoxLineItemRight">
						<img class="mFifthItemImg" src="../../assets/aboutLanshu/service.png" alt="">
						<div class="mFifthItemTitle1">服务理念</div>
						<div class="ideaTitle3">Service concept</div>
						<div class="mFifthItemTitle2">消费者说好才是真的好</div>
					</div>
				</div>
				<div class="mFifthBoxMainThird mFifthBoxLine">
					<div class="mFifthBoxLineItemLeft">
						<img class="mFifthItemImg" src="../../assets/aboutLanshu/market.png" alt="">
						<div class="mFifthItemTitle1">营销理念</div>
						<div class="ideaTitle3">Marketing concept</div>
						<div class="mFifthItemTitle2">把握行业脉搏  引领行业潮流</div>
					</div>
					<div class="mFifthBoxLineItemRight">
						<img class="mFifthItemImg" src="../../assets/aboutLanshu/talent.png" alt="">
						<div class="mFifthItemTitle1">人才理念</div>
						<div class="ideaTitle3">Talent concept</div>
						<div class="mFifthItemTitle2">员工的成长才是企业的财富</div>
					</div>
				</div>
			</div>
		</div>

		<div class="mSixBox">
			<div class="titleBox">
				<div class="tb_left">
					<div class="aboutLine"></div>
					<div class="aboutTitle1">企业核心人物</div>
					<div class="aboutTitle2">COMPANY TEAM</div>
				</div>
				<div class="tb_right">
					<img src="../../assets/mImg/icon.png" alt="">
				</div>
			</div>
			
			<!-- <el-carousel class="carouselBoxMainLarge" :interval="3000" type="card" height="320px"> -->
				<!-- <el-carousel-item class="carouselBoxMain" v-for="(item,index) in teamData" :key="index"> -->
					<div class="teamBox" >
						<div class="carouselBoxMain" v-for="(item,index) in teamData" :key="index">
						<div class="carouselBox">
							<img class="carouselBoxItemImg" :src="item.img" alt="">
							<div class="carouselBoxMainMask">
								<div class="carouselBoxMainMaskTitle1">{{item.teamtitle1}}</div>
								<div class="yszi">{{item.teamtitle3}}</div>
								<div class="carouselBoxMainMaskTitle2">{{item.teamtitle2}}</div>
							</div>
						</div>
					</div>
					</div>
					
					
				<!-- </el-carousel-item> -->
			<!-- </el-carousel> -->
		</div>

		<div class="mSevenBox">
			<div class="titleBox">
				<div class="tb_left">
					<div class="aboutLine"></div>
					<div class="aboutTitle1">企业荣誉</div>
					<div class="aboutTitle2">ENTERPRISE HONOR</div>
				</div>
				<div class="tb_right">
					<img src="../../assets/mImg/icon.png" alt="">
				</div>
			</div>
			<!-- <div class="aboutTitle1">企业荣誉</div>
			<div class="aboutLine"></div>
			<div class="aboutTitle2">ENTERPRISE HONOR</div> -->
			<wc-swiper class="swiperItemBox">
				<wc-slide v-for="(item,index) in honorData" :key="index" :class="honourStyle[index]">
					<div class="swiperItemBoxMain">
						<div class="itemImgBox" v-for="(imgItem,index) in item.img" :key="index">
							<img class="itemImgBoximg" :src="imgItem.honorimg" alt="">
						</div>
					</div>
				</wc-slide>
			</wc-swiper>
		</div>


		<div class="footerBoxMain">
			<div class="footerBoxMainMiddle">
				<div class="footerBoxTitle">快捷导航</div>
				<div class="bottomNavFirst bottomNav1">
					<div class="mHomeName">
						<router-link to="/m" tag="a">首页</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mDynamicLanshu" tag="a">菩提基金会</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav2">
					<div class="mHomeName">
						<router-link to="/maboutLansu" tag="a">关于兰树</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mhuaibrand" tag="a">兰树品牌</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav3">
					<div class="mHomeName">
						<router-link to="/mbrandLansu" tag="a">美业菩提</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mTrends" tag="a">兰树动态</router-link>
					</div>
				</div>
				<div class="footerBoxTitle footerBoxTitle2">联系我们</div>
				<div class="contactFirst contactFirst1">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/emailIcon.png" alt="">
					</div>
					<div class="contactContent">
						邮箱：postermaster@lasur.com

					</div>
				</div>
				<div class="contactFirst contactFirst2">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/phoneIcon.png" alt="">
					</div>
					<div class="contactContent">
						电话：0571-89025888
					</div>
				</div>
				<div class="contactFirst contactFirst3">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/gpsIcon.png" alt="">
					</div>
					<div class="contactContent">
						浙江省杭州市之江东路越秀·维多利中心A座 17楼
					</div>
				</div>
			</div>
			<div class="bottomLine"></div>
			<div class="codeBoxMain">
				<div class="footerBoxHeaderLeft">
					<img class="codeImg" src="../../assets/code.png" alt="">
					<span class="codeText">兰树公众号</span>
				</div>
				<div class="footerBoxHeaderRight">
					<img class="codeImg" src="../../assets/xcxNew.jpg" alt="">
					<span class="codeText">兰树云小程序</span>
				</div>
			</div>
			<div class="footerBoxBottom">
				<div class="footerLeft">
					Copyright © 2023 兰树化妆品股份有限公司
				</div>
				<div class="footerLeft">
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a><br />
					<img
						src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-13_13-29-23_21054.png" /><a
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
						33052102000740号</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			drawer: false,
			direction: 'ltr',
			swiperData: [
				{
					id: 1,
					img: require('../../assets/newLasur/aboutItem1.png'),
					title1: '梦想',
					title2: '传播美·奉献爱·圆梦想',
				},
				{
					id: 2,
					img: require('../../assets/newLasur/aboutItem2.png'),
					title1: '使命',
					title2: '传承中医国粹 弘扬中医美容'
				},
				{
					id: 3,
					img: require('../../assets/newLasur/aboutItem3.png'),
					title1: '愿景',
					title2: '将美容师培养成美容医师'
				}
			],
			styleData: [
				"first",
				"second",
				"third",
				"forth",
				"fifth"
			],
			honourStyle: [
				"first",
				"second",
				"third",
				"forth"
			],
			cultureData: [
				{
					id: 1,
					img: require('../../assets/newLasur/cultureItem1.png'),
					title1:'Ren',
					text:'同情、关心、爱护',
				},
				{
					id: 2,
					img: require('../../assets/newLasur/cultureItem2.png'),
					title1:'Yi',
					text: '正直、正当、道义'
				},
				{
					id: 3,
					img: require('../../assets/newLasur/cultureItem3.png'),
					title1:'Li',
					text:'礼仪、礼貌、礼节',
				},
				{
					id: 4,
					img: require('../../assets/newLasur/cultureItem4.png'),
					title1:'Zhi',
					text: '明是非、辨善恶、知人知己'
				},
				{
					id: 5,
					img: require('../../assets/newLasur/cultureItem5.png'),
					title1:'Xin',
					text: '诚实、守信、坚定、信赖'
				}
			],
			teamData: [
				{
					id: 1,
					img: require('../../assets/newLasur/jingying1.png'),
					teamtitle1: '钟鸣',
					teamtitle2: '兰树股份创始人，董事长',
					teamtitle3:'Zhongming',
				},
				{
					id: 2,
					img: require('../../assets/newLasur/jingying2.png'),
					teamtitle1: '戴冰蓝',
					teamtitle2: '兰树股份总经理',
					teamtitle3:'Daibinglan',
				},
				// {
				// 	id: 3,
				// 	img: require('../../assets/newLasur/jingying3.png'),
				// 	teamtitle1: '陈绍俊',
				// 	teamtitle2: '兰树股份市场部总监',
				// 	teamtitle3:'Chenshaojun',
				// }
			],
			honorData: [
				{
					id: 1,
					img: [
						{
							id: 1,
							honorimg: require('../../assets/aboutLanshu/07.jpg'),
						},
						{
							id: 2,
							honorimg: require('../../assets/aboutLanshu/01.png'),
						},{
							id: 3,
							honorimg: require('../../assets/aboutLanshu/02.png'),
						},
						{
							id: 4,
							honorimg: require('../../assets/aboutLanshu/03.png'),
						}
					]
				},
				{
					id: 2,
					img: [
						{
							id: 1,
							honorimg:require('../../assets/aboutLanshu/04.png'),
						},
						{
							id: 2,
							honorimg: require('../../assets/aboutLanshu/05.png'),
						},
						
						{
							id: 3,
							honorimg: require('../../assets/aboutLanshu/06.png')
						}
					]
				},
				// {
				// 	id: 3,
				// 	img: [
				// 		{
							
				// 			id: 1,
				// 			honorimg: require('../../assets/aboutLanshu/honnerImgNew.jpg'),
						
				// 		},
						
				// 	]
				// },
				// {
				// 	id: 4,
				// 	img: [
				// 		{
				// 			id: 1,
				// 			honorimg: require('../../assets/aboutLanshu/honnerImgNew.jpg'),
				// 		},
				// 		{
				// 			id: 2,
				// 			honorimg: require('../../assets/aboutLanshu/06.png')
				// 		}
				// 	]
				// }
			]
		}
	},
	methods: {
		handleClose(done) {
			done()
		},
		open() {
			this.drawer = true
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleCloseMenu(key, keyPath) {
			console.log(key, keyPath);
		}
	}
}
</script>

<style scoped>
.mSecond {
	width: 100%;
}
.mAboutLansuContainer {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #f4f6f5;
}

.mFirst {
	width: 100%;
}

.mFirstBox {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 99;
}


.mFirstBoxImgBox {
	width: 100%;
	margin-top: 0.5rem;
}

.mFirstBoxImg {
	width: 50%;
	float: left;
	position: relative;
	left: 0.5rem;
}

.firstBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 3.5rem;
}



.mhomeSecondBox {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #f4f6f5;
	/* padding-bottom:10rem; */
	padding-bottom: 3rem;
}

.titleBox{
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	/* background: #80FF00; */
}
.tb_left{
	width: 18.75rem;
	height: 7.5rem;
	position: relative;
	/* background: #0839DE; */
}

.tb_right{
	width: 5.25rem;
	height: 1rem;
	margin-right: 1.4rem;
	margin-top: 1.8rem;
}
.tb_right img{
	width: 100%;
	height: 100%;
}

.aboutTitle1 {
	font-size: 1.5rem;
	color: #0839DE;
	font-family: SourceHanSansCN-Bold;
	font-weight: 400;
	position: absolute;
	top: 1.5rem;
	left: 2.3rem;
	/* margin-top: 1rem; */
	/* line-height: 50px; */
}
.aboutLine{
	
	width: 0.25rem;
	height: 3.3rem;
	background: #80FF00;
	position: absolute;
	top: 1.8rem;
	left: 1.5rem;
}

.aboutTitle2 {
	/* margin-top: 0.1rem; */
	font-size: 0.8rem;
	color: #888888;
	position: absolute;
	top: 3.8rem;
	left: 2.3rem;
}

.mhomeSecondMain {
	width: 85%;
	flex-direction: column;
	display: flex;
	align-items: center;
}

.mhomeSecondMainimg {
	width: 100%;
	border-radius: 1rem;
	margin-top: 1rem;

}

.mhomeSecondMainText1 {
	font-family: SourceHanSansCN-Light;
	font-weight: 300;
	font-size: 1rem;
	color: #000;
	/* margin-top: 0.5rem; */
	line-height: 20px;
}

.mhomeSecondMainText2 {
	font-family: SourceHanSansCN-Light;
	font-weight: 300;
	font-size: 1rem;
	color: #000;
	margin-top: 1rem;
	line-height: 20px;
}

.seeMore {
	width: 10rem;
	margin-top: 1.5rem;
}

.mThirdBox {
	width: 100%;
	flex-direction: column;
	display: flex;
	align-items: center;
	background-color: #f4f6f5;
	/* margin-top: 1rem; */
}

.valueImg{
	width: 90%;
	margin-bottom: 1rem;
}
.valueImg img{
	width: 100%;
	height: 100%;
}

.mForthBox {
	width: 100%;
	flex-direction: column;
	display: flex;
	align-items: center;
	background-color: #F4F5F5;
	padding-bottom: 4rem;
	margin-top: 2rem;
}

.swiperItemBox {
	margin-top: 1rem;
}

.swiperItemBox1 {
	/* margin-top: 1rem; */
	background: url(../../assets/mImg/mCultureBg.png) no-repeat center 0px;
	background-position:center 0px;
	background-size: cover;
	overflow: hidden;
	width: 100%;
}

.swiperBoxMain {
	width: 80%;
	/* padding-bottom: 2rem; */
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 8%;
}

.swiperBoxMain2 {
	width: 80%;
	/* padding-bottom: 2rem; */
	margin: 0 auto;
	border-radius: 2rem;
	/* background-color: #FFFFFF; */
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 10%;
	/* background: url(../../assets/mImg/mCultureBg.png) no-repeat center 0px;
	background-position:center 0px;
	background-size: cover;
	overflow: hidden; */
}

.swiperBoxMainImg {
	width: 100%;
	border-radius: 1rem;
}



.swiperBoxMainTitle1 {
	font-size: 1.5rem;
	color: #000000;
	margin-top: 1rem;
}

.swiperBoxMainTitle2 {
	color: #666666;
	font-size: 1rem;
}

.cultureBoxImg {
	width: 7rem;
	margin-top: 2rem;
}

.cultureText {
	font-size: 1rem;
	color: #fff;
	margin-top: 1rem;
}

.cultureTitle{
	font-size: 1.125rem;
	font-family: AntroVectra;
	font-weight: 500;
	color: #80FF00;
	text-align: center;
	position: absolute;
	bottom: 5rem;
	
}


.mFifthBox {
	width: 100%;
	flex-direction: column;
	display: flex;
	align-items: center;
	background-color: #f4f6f5;
	padding-bottom: 3rem;
	padding-top: 2rem;
	/* margin-top: 2rem; */
}

.mFifthBoxMain {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	background: url(../../assets/mImg/linianbg.png) no-repeat center 0px;
	background-position:left 0px;
	background-size: cover;
	overflow: hidden; 
	padding-bottom: 2rem;
}

.mFifthBoxLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 0.5rem;
}

.mFifthBoxLineItemLeft {
	width: 49%;
	display: flex;
	flex-direction: column;
	align-items: center;
	/* background-color: #0839DE; */
	/* border-radius: 0.5rem; */
}

.mFifthBoxLineItemRight {
	width: 50%;
	display: flex;
	flex-direction: column;
	align-items: center;
	/* background-color: #0839DE;
	border-radius: 0.5rem; */
}

.mFifthItemImg {
	width: 3rem;
	margin-top: 1.5rem;
}

.mFifthItemTitle1 {
	color: #fff;
	font-size: 1.35rem;
	font-weight: 600;
	margin-top: 1rem;
	z-index: 99;
}
.ideaTitle3{
		font-size:0.8rem;
		font-family: AntroVectra;
		font-weight: 400;
		color: #80FF00;
		/* line-height: 21px; */
		margin-top: -0.5rem;
	}

.mFifthItemTitle2 {
	color: #fff;
	font-size: 0.8rem;
	margin-top: 0.1rem;
	padding-bottom: 1rem;
	width: 90%;
	text-align: center;
}

.mFifthBoxMainFirst {
	margin-top: 1rem;
}


.mSixBox {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #F4F5F5;
	padding-bottom: 3rem;
	padding-top: 2rem;
}

.carouselBox {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	border-radius: 1rem;
	overflow: hidden;
}

.teamBox{
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	overflow: hidden;
	padding: 10px 0;
	/* margin-top: 2rem; */
	
}

.carouselBoxMain {
	width: 46%;
	margin: 0 auto;
	border-radius: 1rem;
	
}

.carouselBoxMainLarge {
	width: 95%;
	margin: 0 auto;
	margin-top: 1rem;
}

.carouselBoxMainMask {
	width: 100%;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #2C5EFF;
	bottom: 0;
	z-index: 999;
	padding-bottom: 0.5rem;
}

.carouselBoxMainMaskTitle1 {
	color: #fff;
	line-height: 1.875rem;
	font-size: 1.25rem;
	font-weight: 500;
	margin-top: 0.5rem;
	z-index: 999;
}
.yszi{
		font-size:0.875rem;
		font-family: AntroVectra;
		font-weight: 400;
		color: #80FF00;
		margin-top: -1rem;
}


.carouselBoxMainMaskTitle2 {
	color: #fff;
	font-size: 0.875rem;
	line-height: 1.875rem;
	margin-top: -0.8rem;
}

.mSevenBox {
	width: 100%;
	flex-direction: column;
	display: flex;
	align-items: center;
	background-color: #F4f6f5;
	padding-bottom: 2rem;
}

.swiperItemBoxMain {
	width: 100%;
	margin: 0 auto;
	display: flex;
	align-content: space-between;
	flex-direction: row;
	flex-wrap: wrap;
	padding-bottom: 2rem;
}

.itemImgBox {
	width: 46%;
	margin: 0 auto;
	margin-top: 0.8rem;
}

.itemImgBoximg {
	width: 100%;
}

.carouselItem {
	width: 100%;
	margin: 0 auto;
	display: flex;
	align-content: center;
	align-items: center;
	flex-direction: row;
}

.forth .itemImgBox {
	width: 30% !important;
}



.footerFirstLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 1rem;
}

.footerSecondLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 0.5rem;
}

.footerItem {
	list-style: none;
}

.footerItem a {
	color: #333333;
	font-size: 0.9375rem;
	text-decoration: none;
	margin-left: 0.5rem;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9375em;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
	margin-left: 1rem;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.9375rm;
	font-weight: 400;
	color: #222222;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerBoxHeader {
	width: 60%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 1rem;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}



.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.emailBox {
	font-size: 0.875rem;

	font-weight: 400;
	color: #222222;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;

	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
	text-align: center;
}

.footerLine {
	width: 100%;
	height: 1px;
	display: flex;
	background: #000000;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}


.footerBoxMainMiddle {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
}

.footerBoxTitle {
	color: #FFFFFF;
	font-size: 1rem;
	font-weight: 500;
}

.bottomNavFirst {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.mHomeName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.ptjjhName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.contactFirst {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.contactImgBox {
	width: 0.8rem;
}

.contactImg {
	width: 100%;
}

.contactContent {
	color: #FFFFFF;
	font-size: 0.7rem;
	opacity: 0.7;
	margin-left: 0.5rem;
}

.bottomLine {
	width: 100%;
	height: 2px;
	background: #FFFFFF;
	opacity: 0.1;
	margin-top: 1.5rem;
}

.footerBoxTitle2 {
	margin-top: 1.5rem;
}

.contactFirst1 {
	margin-top: 1rem;
}

.codeBoxMain {
	width: 50%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	margin-top: 1.5rem;
}


.footerBoxMain {
	width: 100%;
	background-color: #2c5eff;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
	padding-bottom: 1rem;
}


.codeImg {
	width: 80%;
}

.codeText {
	font-size: 0.5em;
	color: #FFFFFF;
	line-height: 20px;
	opacity: 0.7;
	/* margin-top: 0em; */
}


.footerLeft {
	text-align: center;
	font-size: 0.9em;
	color: #FFFFFF;
	line-height: 24px;
	opacity: 0.7;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #FFFFFF;
	opacity: 0.7;
}


.contactFirst2 {
	margin-top: 0.5rem;
}

.contactFirst3 {
	margin-top: 0.5rem;
}

.carouselBoxItemImg {
	width: 100%;
}

/* 新导航栏 */
.menuBox {
	position: fixed;
	width: 100%;
	display: flex;
	top: 0;
	flex-direction: row;
	background: #FFFFFF;
	padding-top: 0.8rem;
	padding-bottom: 0.5rem;
	align-items: center;
	z-index: 999;
	justify-content: space-between;
	/* background: #0839DE; */
	/* margin-bottom: 0.5rem; */
	/* padding-top: 0.5rem; */

}

.menuImgBox {
	width: 33.33%;
}

.menuImg {
	width: 17%;
	margin-left: 1rem;
}

.lansuImgBox {
	width: 40%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-right: 1rem;
}

.blackBox {
	width: 33.33%;

}

.lansuImg {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mComponents/maboutLansu.vue